// extracted by mini-css-extract-plugin
module.exports = {"root":"topic_root__p8tTA","betaIcon":"topic_betaIcon__2NEEP","infoIcon":"topic_infoIcon__1QF6m","listContainer":"topic_listContainer__3WQAK"};